import {
  getComponentCssUrl,
  getGlobalCssUrl,
} from '@/components/webcomponents/Global/loadDependency'

// Lazy template creation to avoid calling getCdnUrl at module load time
function createNavHeaderLevel0Template() {
  const t = document.createElement('template')
  t.innerHTML = `
<link href="${getGlobalCssUrl()}" rel="stylesheet" />
<link href="${getComponentCssUrl('NavHeader-Level0--wc.css')}" rel="stylesheet" />
`
  return t
}

// Getter function for template
const getTemplateNavHeaderBasicStyles = () => createNavHeaderLevel0Template()
export { getTemplateNavHeaderBasicStyles }
